import FloatingWhats from "../Components/FloatingWhats.jsx";
import Header from "../Components/Header.jsx";
import React, { useState } from "react";
import { Box, Button, Grid2, IconButton, Modal } from "@mui/material";
import BottomBar from "../Components/BottomBar.jsx";
import Footer from "../Components/Footer.jsx";
import styles from "../styles/ProdCel.css"
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Card from "../Components/Card.jsx";

const images = [
    "/images/bsds-1.png",
    "/images/bsds-2.png",
    "/images/bsds-3.png",
    "/images/bsds-4.png",
    "/images/bsds-5.png",
];

const ProdCelBSDS = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const nextImage = () => {
        setCurrentIndex((prev) =>
            prev === images.length - 1 ? 0 : prev + 1
        );
    };

    const prevImage = () => {
        setCurrentIndex((prev) =>
            prev === 0 ? images.length - 1 : prev - 1
        );
    };

    return (
        <div className="container">
            <FloatingWhats/>
            <Header/>    
            <div className="content">
                <div className="bannerInterno-container from-top">
                    <div className="bannerInterno-content">
                        <div className="bannerInterno">
                            <h1 className="bannerInterno-title">BSDS<br/>Digital</h1>
                            <img className="bannerInterno-img" src="/images/banner-bsds.png" alt="Banner Célula BSDS"/>
                        </div>
                    </div>
                </div>
                <div className="caminho">
                    <div className="caminho-content from-left">
                        <a className="caminho-link" href="/">Início</a>
                        <span className="caminho-separador">/</span>
                        <a className="caminho-link" href="/produtos">Produtos</a>
                        <span className="caminho-separador">/</span>
                        <a className="caminho-link" href="/produtos/pesagem-rodoviaria">Pesagem Rodoviária</a>
                        <span className="caminho-separador">/</span>
                        <span className="caminho-atual">BSDS</span>
                    </div>
                </div>
                <div className="produto-header">
                    <div className="produto-header-content">
                        <div className="produto-header-left from-left">
                            <div className="produto-header-fotosBox">
                                <img className="produto-header-foto" src={images[currentIndex]} alt="Produto" />
                                <button className="produto-header-btn left" onClick={prevImage}><ChevronLeftIcon sx={{ fontSize: 40 }}/></button>
                                <button className="produto-header-btn right" onClick={nextImage}><ChevronRightIcon sx={{ fontSize: 40 }} /></button>
                            </div>
                        </div>
                        <div className="produto-header-right from-right">
                            <div className="produto-header-infoBox">
                                <div className="produto-header-infoBox1">
                                    <h1 className="produto-header-name from-right">BSDS Digital</h1>
                                    <h4 className="produto-header-sku from-right">ID:504574</h4>
                                </div>
                                <div className="produto-header-descricao">
                                    <span className="produto-header-info"><strong>Fabricante:</strong> Weightech</span>
                                    <span className="produto-header-info"><strong>Tipo de Sinal:</strong> Digital</span>
                                    <span className="produto-header-info"><strong>Classe de Proteção:</strong> IP69K</span>
                                    <span className="produto-header-info"><strong>Material:</strong> Aço Inoxidável</span>
                                    <span className="produto-header-info"><strong>Capacidade Máxima:</strong> 50 Toneladas</span>
                                </div>
                                <div className="produto-header-infoBox3">
                                    <h3 className="produto-header-chamada">
                                        <span style={{color:'#474747'}}>Alguma Dúvida?</span>
                                    </h3>
                                    <a href="https://wa.me/+556599547518"><Button sx={{fontFamily:'Inter', textTransform:'none', width:'100%', height:90, backgroundColor:'#474747', borderRadius:'8px', color:'#fff', fontSize:'20px','&:hover':{backgroundColor:'#7D1115'}}}>Falar com Vendedor</Button></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="downloads">
                    <div className="downloads-content">
                        <h3 className="downloads-title">Arquivos para Download</h3>
                        <div className="downloads-links">
                            <a className="downloads-link" href="https://drive.google.com/file/d/13cI3wvNkYskK2zp-PqA3oDwfI96bxBNt/view?usp=drive_link" target="_blank" rel="noopener noreferrer"><img src="/images/icons/arquivo.svg" className="download-icon"/>Ficha Técnica</a>
                        </div>
                    </div>
                </div>
                <div className="cel-descricao">
                    <div className="cel-descricao-content">
                        <h2 className="cel-descricao-title">Descrição</h2>
                        <div className="cel-descricao-text">
                            <p>Durabilidade, confiabilidade e praticidade nas conexões, instalação e manutenção, com eletrônica robusta, construção em aço inox e certificação C4.</p>
                            <p><strong>GRAU DE PROTEÇÃO IP69K</strong>
                            Construída em aço inoxidável com grau de proteção IP69K, possuindo máxima proteção contra infiltração de água (alta pressão ou limpeza a vapor).</p>
                            <p><strong>PRECISÃO GARANTIDA</strong>
                            Com certificado de precisão C4, emitido pela NMi Certin B.V. (Holanda), a BSDS passa a contar com precisão reconhecida internacionalmente, em conformidade com os padrões da OIML.</p>
                            <p><strong>ELETRICAMENTE ROBUSTA</strong>
                            Testada contra transientes elétricos de 80kA, ou seja, é extremamente robusta eletricamente, podendo até mesmo suportar raios sem danificar.</p>
                            <p><strong>CONECTORES DE CATEGORIA MILITAR</strong>
                            Conectores construídos em aço inoxidável com acoplamento rosqueado, revestidos por uma cápsula de silicone reforçado, com grau de proteção IP69K, resistente à sujeira, agentes químicos e submersão.</p>
                            <p><strong>CABO BLINDADO</strong>
                            Cabo de 10 metros, blindado com uma malha de aço inoxidável que o protege contra intempéries e elimina totalmente o risco de atuação de roedores.</p>
                            <p><strong>ATÉ 16 CÉLULAS SEM CAIXA DE JUNÇÃO</strong>
                            Os dois conectores das células BSDS , possibilitam a interligação de até 16 células em série na plataforma, com calibração e ajustes feitos digitalmente, simplificando a composição do sistema e otimizando operações de manutenção.</p>
                            <p><strong>CONEXÃO DIRETA</strong>
                            Cabo de interligação da célula ao indicador de pesagem com 20, 50 ou 10 metros de comprimento, revestido por malha externa em aço inoxidável (Medidas especiais sob consulta).</p>
                            <p><strong>MOVIMENTAÇÃO</strong>
                            Castanhas com fendas anti-rotação tornam a montagem mais segura e resistente, além de permitir tolerância à movimentação lateral seguindo o sentido longitudinal da plataforma.</p>
                        </div>
                    </div>
                </div>
                <div className="cel-dimensao">
                    <div className="cel-dimensao-content" style={{textAlign:'center'}}>
                        <h2 className="cel-dimensao-title">Dimensões (mm)</h2>
                        <img className="cel-dimensao-img cel-bsds" src="/images/dim-bsds.jpg" alt="Dimensões Célula BSDS"/>
                    </div>
                </div>
                <div className="model">
                    <div className="model-content">
                        <iframe src="https://weightech2.autodesk360.com/shares/public/SH286ddQT78850c0d8a46932bb1d44da9d20?mode=embed" height="450" width="100%"></iframe>
                    </div>
                </div>

                <BottomBar/>
                <Footer/>
            </div>
        </div>
    )
}
export default ProdCelBSDS;